<template lang="html">
    <entity-page v-bind:loading="progress">
        <template slot="header-left">
            <span v-if="operation.payment_number">{{'№ операции: ' + operation.payment_number}}</span>
            <span v-else>Новая операция</span>
        </template>
        <template slot="header-center"></template> 
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>
        <div slot="default">
            <div class="row">
                <z-input
                    v-model="operation.payment_number" v-bind:disabled="progress" class="col-6"
                    name="payment_number" id="payment_number" label="Номер операции (crm)" v-bind:error="errors.first('payment_number')"
                ></z-input>
                <z-input
                    v-model="operation.ones_id" class="col-6" disabled readonly
                    name="ones_id" id="ones_id" label="Номер операции (1С)" v-bind:error="errors.first('ones_id')"
                ></z-input>
            </div>
            <div class="row">
                <z-select
                    class="col-6"
                    id="operation_type" name="operation_type" label="Тип операции"
                    v-model="operation.type" v-bind:disabled="progress"
                    v-validate="'required'" v-bind:required="true"
                    v-bind:error="errors.first('operation_type')"
                >
                    <option value="1">Приход</option>
                    <option value="2">Расход</option>
                </z-select>

                <z-select
                    id="payment_method_id" name="payment_method_id" label="Способ оплаты" class="payment-method col-6"
                    v-model="operation.payment_method_id" v-bind:required="true" 
                    v-validate="'required'" data-vv-name="payment_method_id" v-bind:data-vv-as="' '"
                    v-bind:error="errors.first('payment_method_id')"
                    v-bind:disabled="isCreated && !!parseInt(operation.payment_method_id)"
                >
                    <option v-for="item in paymentMethods" v-bind:value="item.id" v-bind:key="('payment-method-' + item.id)">{{item.name}}</option>
                </z-select>                  
            
                <z-select
                    class="col-6"
                    id="company_id" name="company_id" label="Получатель" v-bind:disabled="progress"
                    v-model="operation.company_id" v-bind:required="true"
                    v-validate="'required'" v-bind:data-vv-as="' '"
                    v-bind:error="errors.first('company_id')"
                >
                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="('company-' + company.id)">{{ company.name }}</option>
                </z-select>

                <z-input-autocomplete
                    class="col-6"
                    id="customer_id"
                    name="customer_id"
                    label="Плательщик"
                    v-bind:disabled="progress"
                    v-model="operation.customer_id"
                    v-bind:update-on-input="true"
                    v-bind:callback="searchCustomerByName"
                    v-on:clear="clearCustomer"
                    v-bind:length-on-search="5"
                    
                    property="id"
                    display-property="name"
                    display-property-list="name"
                    
                    v-bind:default="operation.customer.name"
                    v-validate="'required'" required
                    v-bind:error="errors.first('customer_id')"
                    data-vv-name="customer_id"
                    v-bind:data-vv-as="' '"
                ></z-input-autocomplete>
            </div>

            <div class="row">
                <z-date
                    label="Дата платежа" placeholder="Дата платежа" class="col-4"
                    format="DD.MM.YYYY HH:mm" type="datetime"
                    v-bind:disabled="progress"
                    v-model="operation.date" required no-margin
                    data-vv-name="date" v-bind:data-vv-as="' '"
                    v-validate="{'required': true}" v-bind:error="errors.first('date')"
                ></z-date>
                <z-input
                    v-model="operation.created_at" class="col-4" disabled readonly
                    name="created_at" id="created_at" label="Дата создания" v-bind:error="errors.first('created_at')"
                ></z-input>
                <z-input
                    v-model="operation.updated_at" class="col-4" disabled readonly
                    name="updated_at" id="updated_at" label="Дата обновления" v-bind:error="errors.first('updated_at')"
                ></z-input>
            </div>

            <z-input
                v-if="operation && operation.deal && operation.deal.first_freight && operation.deal.first_freight.traking_number"
                v-model="operation.deal.first_freight.traking_number" disabled readonly
                name="traking_number" id="traking_number" label="Заявка" v-bind:error="errors.first('traking_number')"
            ></z-input>
          
            <z-input
              v-model="operation.sum" v-bind:disabled="progress" v-bind:readonly="progress" type="number"
              name="sum" id="sum" label="Сумма (руб.)" v-bind:error="errors.first('sum')"
            ></z-input>

            <z-text-area
              v-model="operation.description" v-bind:disabled="progress" v-bind:readonly="progress"
              name="description" id="description" label="Описание" v-bind:error="errors.first('description')"
            ></z-text-area>
        </div>
    </entity-page>
</template>
<script>
    import moment from 'moment';
    import ZInput from '@/components/ZInput';
    import ZTextArea    from '@/components/ZTextArea';
    import ZSelect      from '@/components/ZSelect';
    import ZDate        from '@/components/ZDate';
    import EntityPage   from '@/components/EntityPage.vue';
    import ZIconButton  from '@/components/ZIconButton.vue';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: {ZInputAutocomplete, ZInput, ZTextArea, ZSelect, ZDate, EntityPage, ZIconButton},
        data() {
            return {
                operation: {
                    id: null,
                    ones_id:    null,
                    created_at: null,
                    updated_at: null,
                    company_id: null,
                    payment_number: null,
                    customer_id: null,
                    deal_id: null,
                    description: null,
                    date: null,
                    sum: null,
                    type: null,
                    payment_method_id: null,
                    deal: {},
                    company: {},
                    customer: {}
                }
            }
        },
        computed: {
            /**
             * Объект с флагами загрузи
             * @returns Object
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Флаг загрузки текущего компонента
             * @returns Boolean
             */
            progress() {
                return this.progressObj['load-finance-card'];
            },
            /**
             * Список компаний
             * @returns Array
             */            
            companies() {
                return this.$store.state.companies.companies;
            },
            /**
             * Список контрагентов, отфильтрованный после поиска
             * @returns Array
             */            
            customers() {
                return this.$store.state.customers.customers.map(item => { return {id: item.id, name: item.name}; });
            },
            /**
             * Список способов оплаты
             * @returns Array
             */
            paymentMethods() {
                return this.$store.state.cost.payment_methods;
            },
            /**
             * Флаг того, что платёжка уже была создана и имеет ID
             * нужен чтобы не дать пользователю править созданные из 1С платёжки
             */
            isCreated() {
                return this.operation.id && this.operation.id != 'new' && !this.progress
            }
        },
        watch: {
            '$route.params.operation_id'() {
                this.init();
            }
        },
        created() {
            this.init();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('openRightPanel');
                this.$store.commit('setTitle', 'Финансы | Новая запись');

                if (!this.companies      || !this.companies.length)      this.getCompanies();
                if (!this.paymentMethods || !this.paymentMethods.length) this.getPaymentMethods();

                if (this.$route.params.operation_id != 'new') this.getOperation();
            },
            /**
             * Возвращает пользователя на предыдущую страницу
             * Обрабочик события click, на кнопке "Закрыть"
             */
            back() {
                this.$router.push({name: 'Operations', query: this.$route.query });
            },
            /**
             * Сохраняет/Обновляет платёжку (фин. операцию)
             * 
             * @returns Promise
             */
            save() {
                this.$store.commit('showProgressBar', 'load-finance-card');
                return this.$store.dispatch(this.operation.id ? 'finance/putOperation' : 'finance/postOperation', {
                    id: this.operation.id ? this.operation.id : null,
                    deal_id:           this.operation.deal_id           ? this.operation.deal_id           : null,
                    customer_id:       this.operation.customer_id       ? this.operation.customer_id       : null,
                    company_id:        this.operation.company_id        ? this.operation.company_id        : null,
                    payment_method_id: this.operation.payment_method_id ? this.operation.payment_method_id : null,
                    payment_number:    this.operation.payment_number    ? this.operation.payment_number    : null,
                    description:       this.operation.description       ? this.operation.description       : null,
                    date: this.operation.date ? moment(this.operation.date).format('DD-MM-YYYY HH:mm:ss')  : null,
                    sum:  this.operation.sum  ? this.operation.sum  : null,
                    type: this.operation.type ? this.operation.type : null
                }).then(r => {
                    if (!r) return;
                    //TODO: Добавить пересчёт сальдо для контрагента по платёжке
                    //this.$store.dispatch('finance/calculation');
                    this.$root.$emit('reload-table', 'operations');

                    if (this.operation.id) this.getOperation();
                    else this.$router.push({name: 'Operations'});
                }).finally(() => this.$store.commit('hideProgressBar', 'load-finance-card'));
            },
            /**
             * Форматирует платёжку после получения её из API
             * @returns Object
             */
            resolveOperation(operation) {
                if (operation && operation.payment_number) this.$store.commit('setTitle', ('Финансы | Запись ' + operation.payment_number));
                operation.date = (operation.date) ? moment(operation.date).toDate() : moment().toDate();

                return operation;
            },
            /**
             * Получает платёжку по текущему ID в URL
             * @returns Promise
             */
            getOperation() {
                this.$store.commit('showProgressBar', 'load-finance-card');
                this.$store.dispatch('finance/getOperation', { operationId: this.$route.params.operation_id }).then(r => {
                    this.operation = this.resolveOperation(r);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-finance-card'));
            },
            /**
             * Поиск контрагента по имени (для автокомплит поля для ввода контрагента)
             * @returns Promise
             */
            searchCustomerByName(search) {
                return this.$store.dispatch('customers/getCustomers', {
                    page: 1, order_by: 'name', order_type: 'asc', count: 20, cache: true,
                    filter: {model: [['name', '%', search], 'or', ['inn', '%', search]]}
                });
            },
            /**
             * Сбрасывает текущее значение контрагента у платёжки
             */
            clearCustomer() {
                this.operation.customer_id = null;
                this.operation.customer    = Object.assign({}, {});
            },
            /**
             * Получает список компаний - исполнителей из API
             * @returns Promise
             */
            getCompanies() {
                return this.$store.dispatch('companies/getCompanies');
            },
            /**
             * Получает список способов оплаты из API
             * @returns Promise
             */            
            getPaymentMethods() {
                return this.$store.dispatch('cost/getPaymentMethods', {page: 1, order_by: 'id', order_type: 'asc', count: 100, filter: {model: [['active', '=', 1]]}, cache: true});
            },
        }
    }
</script>
<style scoped lang="sass"></style>


// WEBPACK FOOTER //
// Operation.vue?6e1c9716